import React from 'react'
import ReactStringReplace from 'react-string-replace'
import {CSSTransitionGroup} from 'react-transition-group'

export default class GlossaryScreen extends React.Component{
	
	constructor(props) {
		super(props)
		this.state = {
			showPopup: false,
			glossaryWord: '',
			glossaryDefinition: '',
		}
	}

	onSpanClick = e => {
		const {data} = this.props
		const nameAttribute = e.currentTarget.getAttribute('name')

		const glossaryData = data.screen_6.glossary.items
		for(let element of glossaryData){
			let wordPath = element.field
			let word = wordPath.id
			if(word === nameAttribute){
				let newWord = wordPath.content.text_1
				let newDefinition = wordPath.content.text_2
				this.setState({
					glossaryWord: newWord,
					glossaryDefinition: newDefinition,
					showPopup: true,
				})
			}
		}
	}

	onCloseButtonClick = () => {
		this.setState({
			showPopup: false,
		})
	}

	render(){
		const {
			data,
			handler
		} = this.props

		const {
			showPopup,
			glossaryWord,
			glossaryDefinition,
		} = this.state

		const glossaryData = data.screen_6
		const headline = glossaryData.text_1
		let glossaryText = glossaryData.text_2
		const button = glossaryData.button
		const glossaryItems = glossaryData.glossary.items
		const glossaryHeadline = glossaryData.glossary.text
		const glossaryIcon = glossaryData.glossary.close_icon.filename
		const duration = 300

		//underline glossary words
		for(let element of glossaryItems){
			let word = element.field.id
			glossaryText = ReactStringReplace(glossaryText, word, (match, i) => (
			  <span key={match} name={match} onClick={this.onSpanClick}>{match}</span>
			))
		}

		return(
			<div className='glossaryscreen'>
				<CSSTransitionGroup
					transitionName="fade"
					transitionAppear={true}
					transitionAppearTimeout={duration}
					transitionEnterTimeout={duration}
					transitionLeaveTimeout={duration}>
					{showPopup ? 
						<div key={showPopup} className='popup-overlay'>
							<div className='content'>
								<img className='close-icon' src={`assets/icons/${glossaryIcon}`} onClick={this.onCloseButtonClick}/>
								<div className='glossary-headline'>{glossaryHeadline}</div>
								<div className='glossary-word'>{glossaryWord}</div>
								<div className='glossary-definition'>{glossaryDefinition}</div>
							</div>
						</div> : null
					}
				</CSSTransitionGroup>
				<div className='glossaryscreen-content'>
					<div className='headline'>{headline}</div>
					<div className='glossary-text'>{glossaryText}</div>
					<div className='button' onClick={handler}>{button}</div>
				</div>
			</div>
		)
	}
}


// WEBPACK FOOTER //
// ./src/components/glossaryScreen.js